import { featureList } from "@/mocks/comics";

export default function Features() {
  return (
    <section id="features" className="bg-secondary-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-page px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-block rounded-full bg-accent-100 px-4 py-1.5 text-xs font-bold text-accent-800 md:text-sm">
            免费版功能特点
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl">免费版也能让你看得过瘾</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
            别以为免费版会缩水，虫虫漫画把核心体验都留给了免费用户，功能一个不少。
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 md:mt-12 lg:grid-cols-3">
          {featureList.map((item) => (
            <article
              key={item.title}
              className="group rounded-2xl border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-secondary-100 text-accent-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 text-base font-bold md:text-lg">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}